
import { useNavigate } from "react-router-dom";
import { JoyyaHeader } from '../../../components/JoyyaHeader';
import { formatDate } from '../../../dates';

import {
    Image,
    List,
    Message,
    Icon,
    Header,
} from 'semantic-ui-react'
import moment from 'moment';

import { useQuery } from '@apollo/client';

import styles from '../People/teacher/TeacherPeopleView.module.css';

import { GET_BIRTHDAY_PEOPLE } from './data/GET_BIRTHDAY_PEOPLE';

const Birthdays = () => {
  const navigate = useNavigate();
    const { loading , error , data } = useQuery(GET_BIRTHDAY_PEOPLE);

  return (
      <>
        <JoyyaHeader />
          <div className='mobile-frame'>
            <Header as='h2'>
              <span className={styles.header}>
                <Icon name='arrow left' className={styles.pointer} onClick={() => navigate(-1)} />
                People with Birthdays
              </span>
            </Header>
          <List>
          { !loading && !error && data != null && data.birthdays.map((p: any) => (
            <List.Item className={styles.item} style={{cursor: 'pointer'}} key={p.id} onClick={() => navigate(`/people/${p.id}`)}>
              <Image className={styles.image} avatar src={p.photoUrl} size='tiny' style={{ width: '5em', height: '5em', objectFit: 'cover' }}/>
              <List.Content>
                <List.Header className={styles.personName}>{`${p.name}`} ({`${p.identifier}`})</List.Header>
                <List.Description>
                  <span className={styles.scriptName}>
                      {p.scriptName} {`${p.preferredName !== '' ? '(' + p.preferredName + ')' : ''}`}
                  </span>
                </List.Description>
                <List.Description>
                  <span className={styles.scriptName}>
                    Turning {moment().diff(moment(p.dob), 'years') + 1} years old, born <b>{formatDate(p.dob)}</b>
                  </span>
                </List.Description>
              </List.Content>
            </List.Item>
          ))}
          </List>
          { !loading && !error && data != null && data.birthdays.length > 10
            && <><Message>
            <Message.Header>Don't see the person you are looking for?</Message.Header>
            <p>We don't have everyones birthdays on file so might be missing people.</p>
            </Message>
            <br/>
            <br/></>
          }
        </div>
      </>
  )
}

export { Birthdays }
